import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './Nav.css';
import PopUp from '../searchNav/popUp/PopUp';
import { useTranslation } from 'react-i18next';

function Nav() {
  const { t, i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('language', lng);  // เก็บภาษาที่เลือกลงใน localStorage
  };

  const [isMobile, setIsMobile] = useState(false);
  const [modalShow, setModalShow] = useState(false);

  const links = [
    "SLOTS",
    "LIVE CASINO",
    "BETGAMES",
    "TOP MATCHES",
    "LIVE",
    "SPORTS",
    "V-SPORTS",
    "PROMOTIONS",
    "ESPORTS"
  ];

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="row nav">
      <div className="col-12 text-capitalize p-2 ">
        <header className="d-flex align-items-center">
          <PopUp show={modalShow} onHide={() => setModalShow(false)} />
          <div className="col-4 col-sm-2 justify-content-start text-center">
            <Link className="log text-light" style={{ fontSize: "18px", fontWeight: "bold", textDecoration: "none" }} to='/'>
              <img
                src={require("../../assets/RN69.png")}
                alt="RN69"
                width={100}
              />
            </Link>
          </div>

          <div className="col-8 d-none d-lg-block">
            {/* แสดงลิงก์ถ้าจำเป็น */}
          </div>

          <div className="col-8 col-sm-2 d-flex justify-content-center align-items-center text-center gap-2">
            <button
              className="btn bg-danger btn-sm text-white text-capitalize"
              onClick={() => window.location.href = process.env.REACT_APP_LOGIN}
            >
              {t('login')}
            </button>

            <button
              className="btn bg-success-1 btn-sm text-white text-capitalize"
              onClick={() => { window.location.href = process.env.REACT_APP_REGISTER }}
            >
              {t('signup')}
            </button>

            <select
              className="bg-transparent text-white border-1 rounded-2"
              onChange={(e) => changeLanguage(e.target.value)}  // เปลี่ยนภาษาโดยไม่รีเฟรชหน้า
              value={i18n.language}
            >
              <option value="th">TH</option>
              <option value="en">EN</option>
            </select>
          </div>
        </header>
      </div>
    </div>
  );
}

export default Nav;
